import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import { uniqBy } from "lodash"
import Reveal from "react-reveal/Reveal"
import GA from "../components/ga"
import Hero from "../components/hero"
import InnerWrapper from "../components/innerWrapper"
import Layout from "../components/layout"
import SEO from "../SEO"
import { slugify } from "../util/utilityFunctions"
import styles from "./scss/blog.module.scss"

const Blog = ({ data }) => {
  const [activeItem, setActiveItem] = useState(999)
  const initialData = data.allContentfulBlogPost.edges
  const [filteredData, setFilteredData] = useState(initialData)

  const filter = (str, index) => {
    setActiveItem(index)
    if (str === "All") {
      setFilteredData(initialData)
    } else {
      const filtered = initialData.filter(post => {
        return post.node.category === str
      })
      setFilteredData(filtered)
    }
  }

  return (
    <>
      <GA />
      <Layout>
        <SEO
          title="Articles"
          pathname="/articles"
          description={data.contentfulSeo.articlesPageSeoDescription}
        />
        <Hero slogan={data.contentfulBlogPageHeroSlogan.slogan} cta={false} />
        <section className={styles.posts} id="article">
          <InnerWrapper width={1440}>
            <div className={styles.filterContainer}>
              <span>Filter:</span>
              <div className={styles.filters}>
                <button
                  onClick={() => filter("All", 999)}
                  className={activeItem === 999 ? styles.active : ""}
                  type="button"
                >
                  All
                </button>
                {uniqBy(initialData, "node.category").map((edge, index) => {
                  return (
                    <button
                      className={activeItem === index ? styles.active : ""}
                      key={index}
                      type="button"
                      onClick={() => filter(`${edge.node.category}`, index)}
                    >
                      {edge.node.category}
                    </button>
                  )
                })}
              </div>
            </div>
            <div className={styles.container}>
              {filteredData.map((edge, index) => {
                console.log(slugify(edge.node.title))
                return (
                  <Reveal effect="fadeIn" key={index}>
                    <Link to={`/article/${slugify(edge.node.title)}`}>
                      <article className={styles.post}>
                        <picture>
                          <source
                            srcSet={edge.node.image.fluid.srcWebp}
                            type="image/webp"
                          />
                          <source
                            srcSet={edge.node.image.fluid.src}
                            type="image/png"
                          />
                          <img
                            src={edge.node.image.fluid.src}
                            alt={edge.node.image.description}
                          />
                        </picture>
                        <div>
                          <p className={styles.category}>
                            {edge.node.category}
                          </p>
                          <h3 className={styles.title}>{edge.node.title}</h3>
                          {/* <p className={styles.date}>
                            {edge.node.publishDate}
                          </p> */}
                        </div>
                      </article>
                    </Link>
                  </Reveal>
                )
              })}
            </div>
          </InnerWrapper>
        </section>
      </Layout>
    </>
  )
}

export const query = graphql`
  query BlogQuery {
    contentfulSeo {
      articlesPageSeoDescription
    }
    contentfulBlogPageHeroSlogan {
      slogan
    }
    allContentfulBlogPost(sort: { fields: publishDate, order: ASC }) {
      totalCount
      edges {
        node {
          title
          category
          publishDate(formatString: "MMMM Do, YYYY")
          image {
            description
            fluid {
              src
              srcWebp
            }
          }
        }
      }
    }
  }
`
export default Blog
